import { createListenerMiddleware } from "@reduxjs/toolkit";
import { setUserData } from "@/store/slices/UserDataSlice";
import { setUserEntitlement } from "../slices/UserEntitlementSlice";
import { RootState } from "@/models/RootState.type";

export const addEntitlementListenerMiddleware = (listenerMiddleware: ReturnType<typeof createListenerMiddleware>) => {
  listenerMiddleware.startListening({
    actionCreator: setUserData,
    effect: async (action, listenerApi) => {
      const state = listenerApi.getState() as RootState;
      listenerApi.dispatch(setUserEntitlement(state.userData.entitlements));
    },
  });
}